import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';

import { LoginComponent } from './login/login.component';
import { RecuperarSenhaComponent } from './recuperar-senha/recuperar-senha.component';
import { CadastroComponent } from './cadastro/cadastro.component';
import { IconsComponent } from './icons/icons.component';

/*
const routes: Routes = [
    { path: '', redirectTo: 'login' },
    { path: 'login', component: LoginComponent },
    { path: 'recuperar-senha', component: RecuperarSenhaComponent },
    { path: 'primeiro-acesso', component: CadastroComponent }
];
*/

@NgModule({
    imports: [
        SharedModule,
        // RouterModule.forChild(routes)
    ],
    declarations: [
        LoginComponent,
        RecuperarSenhaComponent,
        CadastroComponent,
        IconsComponent
    ],
    exports: [
        RouterModule,
        LoginComponent
    ]
})
export class PagesModule { }
